import React from "react";

export default function LoadingSpinner({ fullScreen = true, size = "default", text = "Loading...", variant = "spinner" }) {
  const sizeClasses = {
    small: { spinner: "h-6 w-6", dots: "h-2 w-2", pulse: "h-8 w-8" },
    default: { spinner: "h-12 w-12", dots: "h-3 w-3", pulse: "h-16 w-16" },
    large: { spinner: "h-16 w-16", dots: "h-4 w-4", pulse: "h-24 w-24" }
  };

  const currentSize = sizeClasses[size] || sizeClasses.default;

  const SpinnerVariant = () => {
    switch (variant) {
      case "dots":
        return (
          <div className="flex gap-2">
            <div className={`${currentSize.dots} bg-[#1e3a5f] rounded-full animate-bounce`} style={{ animationDelay: "0ms" }}></div>
            <div className={`${currentSize.dots} bg-[#1e3a5f] rounded-full animate-bounce`} style={{ animationDelay: "150ms" }}></div>
            <div className={`${currentSize.dots} bg-[#1e3a5f] rounded-full animate-bounce`} style={{ animationDelay: "300ms" }}></div>
          </div>
        );

      case "pulse":
        return (
          <div className="relative">
            <div className={`${currentSize.pulse} bg-[#1e3a5f] rounded-full animate-ping absolute opacity-75`}></div>
            <div className={`${currentSize.pulse} bg-[#1e3a5f] rounded-full relative`}></div>
          </div>
        );

      case "dual-ring":
        return (
          <div className="relative">
            <div className={`${currentSize.spinner} border-4 border-[#1e3a5f] border-t-transparent rounded-full animate-spin`}></div>
            <div className={`${currentSize.spinner} border-4 border-[#FDB913] border-b-transparent rounded-full animate-spin absolute top-0 left-0`} style={{ animationDirection: "reverse", animationDuration: "0.8s" }}></div>
          </div>
        );

      case "gradient":
        return (
          <div className={`${currentSize.spinner} relative`}>
            <div className="absolute inset-0 rounded-full bg-gradient-to-r from-[#1e3a5f] via-[#FDB913] to-[#1e3a5f] animate-spin"></div>
            <div className="absolute inset-1 rounded-full bg-white"></div>
          </div>
        );

      case "bars":
        return (
          <div className="flex gap-1 items-end h-12">
            <div className="w-2 bg-[#1e3a5f] rounded-full animate-bar-1"></div>
            <div className="w-2 bg-[#1e3a5f] rounded-full animate-bar-2"></div>
            <div className="w-2 bg-[#1e3a5f] rounded-full animate-bar-3"></div>
            <div className="w-2 bg-[#1e3a5f] rounded-full animate-bar-4"></div>
          </div>
        );

      default:
        return (
          <div className={`${currentSize.spinner} border-4 border-[#1e3a5f]/20 border-t-[#1e3a5f] rounded-full animate-spin`}></div>
        );
    }
  };

  const content = (
    <div className="flex flex-col items-center gap-4">
      <SpinnerVariant />
      {text && (
        <p className="text-[#1e3a5f] font-medium animate-pulse">
          {text}
        </p>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-white/90 backdrop-blur-sm flex items-center justify-center z-50">
        {content}
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center py-12">
      {content}
    </div>
  );
}